import { render } from "./alert_sf.vue?vue&type=template&id=0d9cff42"
import script from "./alert_sf.vue?vue&type=script&lang=js"
export * from "./alert_sf.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/production_one/web_head/releases/20260331201443/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__